import { useCallback } from 'react';
import { discardLocalSession } from '../services/authentication';
import * as honeybadger from '../services/honeybadger';
import { onUserSignOut } from '../services/user-events';
import { reportError } from '../state/app-state';

// Mirrors the legacy asyncAction error funnel (redux/types.ts) for flows that
// call services directly instead of going through Redux thunks: Honeybadger
// notification, forced sign-out on revoked sessions, and the global error
// reporter for everything else.
export const useServiceErrorHandler = () => {
  return useCallback((error: unknown, onError?: () => void) => {
    console.error(error);

    honeybadger.notify(error, 'serviceCall');

    const errorMessage = error instanceof Error ? error.message : 'Unknown Error';

    if (errorMessage.endsWith('Access denied')) {
      discardLocalSession();
      onUserSignOut();
      window.location.reload();
    } else {
      if (error instanceof Error) reportError(error);
      onError?.();
    }
  }, []);
};
